module.exports = __webpack_public_path__ + "img/stamp.c25a0327.png";